// extracted by mini-css-extract-plugin
export default {"ship_note":"ShipNote_ship_note__IxGVJ"};